import React, { useEffect, useState } from "react";

const PrintHeader = () => {
    const [company, setCompany] = useState({});

    useEffect(() => {
        try {
            const storedData = localStorage.getItem("MasterCompanyDetails");
            if (storedData) {
                const parsed = JSON.parse(storedData);
                setCompany(parsed?.[0] || {});
            }
        } catch (err) {
            console.error("Invalid localStorage data", err);
        }
    }, []);

    return (
        <thead className="print:table-header-group">
            <tr>
                <th
                    colSpan={100} // 🔥 IMPORTANT (full width)
                    style={{
                        border: "none",
                        fontWeight: "normal",
                        width: "100%",
                    }}
                >
                    {/* Header Wrapper */}
                    <div className="bg-white w-full">

                        {/* Top Section */}
                        <div className="px-6 pt-2 pb-3 flex justify-between items-start gap-6 w-full">

                            {/* 🔹 Logo */}
                            <div className="flex items-center">
                                <img
                                    src={company?.CompanyLogoDark || "/shipez-logo.png"}
                                    alt={company?.CompanyName || "Company Logo"}
                                    className="h-12 w-auto object-contain"
                                />
                            </div>

                            {/* 🔹 Address */}
                            <div className="text-right text-xs text-gray-600 leading-4 flex-1">
                                {company?.ProfileAddressPrint
                                    ?.split(",")
                                    ?.map((line, index) => (
                                        <p key={index}>{line.trim()}</p>
                                    ))}
                            </div>

                        </div>

                        {/* 🔹 Bottom Border */}
                        <div className="border-b border-gray-300 w-full" />
                    </div>

                    {/* 🔹 Spacer (helps avoid overlap in print) */}
                    <div style={{ height: "4px" }} />

                </th>
            </tr>
        </thead>
    );
};

export default PrintHeader;
